import { store } from "../store";
import { roleTypes } from "./roleTypes";

const roleVars = Object.entries(roleTypes).reduce(
  (role, [key, value]) => {
    role[key.toUpperCase() as Uppercase<keyof typeof roleTypes>] = value.name;
    return role;
  },
  {} as Record<Uppercase<keyof typeof roleTypes>, string>
);

const { ADMIN, EXECUTIVE, MANAGER } = roleVars;

export const rbacElements: Record<string, string[]> = {
  projectCreateButton: [ADMIN, EXECUTIVE, MANAGER],
  projectDeleteAllButton: [ADMIN, EXECUTIVE],
  projectEditButton: [ADMIN, EXECUTIVE, MANAGER],
  projectAccessTag: [ADMIN, EXECUTIVE],
  projectContextMenu: [ADMIN, EXECUTIVE, MANAGER],
  projectContextMenuDelete: [ADMIN, EXECUTIVE],
  clientsTab: [ADMIN],
  usersTab: [ADMIN, EXECUTIVE],
  dxDocsSelector: [ADMIN, EXECUTIVE, MANAGER],
  dxPeopleActions: [ADMIN, EXECUTIVE, MANAGER],
  dxPeoplePermissions: [ADMIN, EXECUTIVE, MANAGER]
};

export const rbacRoutes: Record<string, string[]> = {
  byPassNavigation: [ADMIN, EXECUTIVE],
  users: [ADMIN, EXECUTIVE],
  clients: [ADMIN],
  projectForm: [ADMIN, EXECUTIVE, MANAGER],
  editProject: [ADMIN, EXECUTIVE, MANAGER]
};

export function hasPermission(allowedRoles: string[]): boolean {
  return (
    allowedRoles.includes(store.getters["peopleCore/getUser"].roleId) ?? false
  );
}

export function hasSogetiPermission(allowedRoles: string[]): boolean {
  return (
    (hasPermission(allowedRoles) &&
      store.getters["peopleCore/getUser"].isSogeti()) ??
    false
  );
}
